import { render } from "./prescriptionPaymentNoWifi.vue?vue&type=template&id=4262a4f8&scoped=true"
import script from "./prescriptionPaymentNoWifi.vue?vue&type=script&lang=js"
export * from "./prescriptionPaymentNoWifi.vue?vue&type=script&lang=js"

import "./prescriptionPaymentNoWifi.vue?vue&type=style&index=0&id=4262a4f8&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4262a4f8"]])

export default __exports__